<template>
  <div id="entry-detail-loading" class="vs-con-loading__container entry_detail">
    <entry-edit :entry="entryDetails" @submit="getDetails" />
    <vs-row>
      <vs-col vs-xs="12" vs-sm="12" vs-lg="8" class="px-2">
        <vs-row>
          <vs-col vs-w="12">
            <vs-card class="card-dh">
              <div slot="header" class="display-flex">
                <vs-col vs-w="8" vs-type="flex">
                  <feather-icon
                    icon="PackageIcon"
                    class="mx-1 icon-title card-header-icon"
                  />
                  <h4>
                    | {{ entryDetails.entry_id }} |
                    {{ entryDetails.client_name }}
                  </h4>
                </vs-col>

                <vs-col
                  vs-w="4"
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                >
                  <vx-tooltip
                    delay="0.5s"
                    :text="$t('edit') | capitalize"
                    tooltipPosition="top"
                    v-if="hasPermission(['IU ENTRY EDIT'])  && entryDetails.status_name != 'Shipped'"
                  >
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="h-5 w-5 mr-4 cursor-pointer"
                      @click="editEntry"
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    delay="0.5s"
                    :text="
                      $i18n.messages[$i18n.locale].request_inventary
                        | capitalize
                    "
                    tooltipPosition="top"
                    v-show="
                      entryDetails.in_inventary == null ||
                      entryDetails.in_inventary == 0
                    "
                  >
                    <feather-icon
                      icon="FlagIcon"
                      :style="{
                        color:
                          entryDetails.in_inventary == 1
                            ? '#44cad4'
                            : '#cdd1d1',
                      }"
                      svgClasses="h-5 w-5 mr-4 cursor-pointer"
                      @click="inventaryEntry"
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    delay="0.5s"
                    :text="
                      entryDetails.locked == 1
                        ? $i18n.messages[$i18n.locale].locked
                        : $i18n.messages[$i18n.locale].unlocked
                    "
                    tooltipPosition="top"
                  >
                    <feather-icon
                      :icon="
                        entryDetails.locked == 1 ? 'LockIcon' : 'UnlockIcon'
                      "
                      :style="{
                        color: entryDetails.locked == 1 ? '#44cad4' : '#cdd1d1',
                      }"
                      svgClasses="h-5 w-5 mr-4 cursor-pointer"
                      @click="lockEntry"
                    />
                  </vx-tooltip>
                </vs-col>
              </div>
              <entry-detail :data="entryDetails" />
            </vs-card>
          </vs-col>
          <vs-col vs-w="12">
            <vs-card>
              <div slot="header" class="display-flex">
                <vs-col vs-w="8" vs-type="flex">
                  <feather-icon
                    icon="PackageIcon"
                    class="mx-1 card-header-icon"
                  />
                  <h4>
                    | {{ $tc('container', 2) | capitalize }} |
                    {{ $t('quantity') | capitalize }}:
                    {{ entryContainers.length }} |
                    {{ entryDetails.weight }}
                    {{ entryDetails.weight_unit }}
                  </h4>
                </vs-col>

                <vs-col
                  vs-w="4"
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                >
                  <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <small class="flex cursor-pointer">
                      <feather-icon
                        icon="MoreVerticalIcon"
                        svgClasses="w-6 h-6 text-grey"
                      ></feather-icon>
                    </small>
                    <vs-dropdown-menu class="w-64">
                      <vs-dropdown-item @click="redirectShowQR">
                        <feather-icon
                          icon="GridIcon"
                          class="inline-block align-middle"
                        ></feather-icon>
                        <span class="inline-block align-middle ml-4"
                          >Show QR</span
                        >
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="redirectPrintQR">
                        <feather-icon
                          icon="GridIcon"
                          class="inline-block align-middle"
                        ></feather-icon>
                        <span class="inline-block align-middle ml-4"
                          >Print QR</span
                        >
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </vs-col>
              </div>
              <vs-tabs>
                <vs-tab
                  :label="$tc('container', 2) | capitalize"
                  icon-pack="feather"
                  icon="icon-box"
                >
                  <div class="tab-text">
                    <entry-containers
                      :data="entryContainers"
                      @containerUpdated="containerUpdated"
                      :entryId="entryId"
                    />
                  </div>
                </vs-tab>
                <vs-tab
                  :label="$t('files') | capitalize"
                  icon-pack="feather"
                  icon="icon-image"
                  :disabled="entryFiles.length === 0"
                >
                  <div class="tab-text">
                    <file-list :data="entryFiles" />
                  </div>
                </vs-tab>
                <vs-tab
                  :label="$t('no_part') | capitalize"
                  icon-pack="feather"
                  icon="icon-layers"
                  :disabled="entryInvoiceList.length === 0"
                >
                  <div class="tab-text">
                    <entry-parts :data="entryInvoiceList" />
                  </div>
                </vs-tab>
                <vs-tab
                  :label="$tc('review_order', 2) | capitalize"
                  icon-pack="feather"
                  icon="icon-check-square"
                  :disabled="entryReviewOrder.length === 0"
                >
                  <div class="tab-text">
                    <entry-review-order :data="entryReviewOrder" />
                  </div>
                </vs-tab>
                <vs-tab
                  :label="$t('load_order') | capitalize"
                  icon-pack="feather"
                  icon="icon-truck"
                  :disabled="entryLoadOrder.length === 0"
                >
                  <div class="tab-text">
                    <entry-load-order :data="entryLoadOrder" />
                  </div>
                </vs-tab>
              </vs-tabs>
            </vs-card>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="12" vs-lg="4" class="px-2">
        <vs-row v-if="entryDetails.destination == 'Northbound' && willcard.signature !== ''">
          <vs-col>
            <vs-card class="card-dh">
              <div slot="header" class="display-flex">
               <vs-row>
                  <vs-col  vs-type="flex">
                    <feather-icon icon="Edit3Icon" class="mx-1 icon-title" />
                    <h4 class="px-2 mt-3">{{ $t('signature') | capitalize }}</h4>
                  </vs-col>
                </vs-row>
              </div>
              <vs-row>
                <vs-col>
                  <img :src="willcard.signature" alt="" class="w-full img-signature">
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col>
                  <h4 class="text-center"> {{ willcard.name | capitalize}}</h4>
                </vs-col>
              </vs-row>
            </vs-card>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col>
            <vs-card>
              <div slot="header" class="display-flex">
                <vs-row>
                  <vs-col vs-w="6" vs-type="flex">
                    <feather-icon icon="ClockIcon" class="mx-1 icon-title" />
                    <h4 class="px-2 mt-3">{{ $t('timeline') | capitalize }}</h4>
                  </vs-col>

                  <vs-col
                    vs-w="6"
                    vs-type="flex"
                    vs-justify="flex-end"
                    vs-align="center"
                  >
                    <vs-button
                      color="success"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="openCommentSidebar"
                    >
                      {{ $t('add') | capitalize }}
                    </vs-button>
                  </vs-col>
                </vs-row>
              </div>
              <entry-add-comment
                :entry="entryId"
                @reload="reload"
                @add="addComment"
              />
              <timeline :data="timeline" />
            </vs-card>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <vs-popup :title="$t('confirm')" :active.sync="confirmActive">
      <p>
        {{ $t('are_you_sure') }}
        {{ $t('this_will_request_a_inventary') | capitalize }}
      </p>
      <vs-row vs-align="center" vs-type="flex" vs-justify="center" class="mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          class="mt-2 px-2"
        >
          <vs-button
            ref="loadableButton"
            id="link-button-loading"
            class="w-full vs-con-loading__container"
            color="primary"
            type="filled"
            :disabled="disabledSubmitButton"
            @click="updateInventary"
            >{{ submitButtonText }}</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          class="mt-2 px-2"
        >
          <vs-button
            color="primary"
            type="border"
            class="w-full"
            :disabled="disabledSubmitButton"
            @click="confirmActive = false"
            >{{ $t('cancel') }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup :title="$t('confirm')" :active.sync="confirmActiveLock">
      <p>
        {{ $t('are_you_sure') }}
        {{ $t('this_entry_will_change_to') | capitalize }}
        {{ statusLockedNext }}.
      </p>
      <vs-row vs-align="center" vs-type="flex" vs-justify="center" class="mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          class="mt-2 px-2"
        >
          <vs-button
            ref="loadableButton"
            id="link-button-loading"
            class="w-full vs-con-loading__container"
            color="primary"
            type="filled"
            :disabled="disabledSubmitButton"
            @click="updateLock"
            >{{ submitButtonText }}</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          class="mt-2 px-2"
        >
          <vs-button
            color="primary"
            type="border"
            class="w-full"
            :disabled="disabledSubmitButton"
            @click="confirmActiveLock = false"
            >{{ $t('cancel') }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import EntryDetail from './components/EntryDetail.vue'
import EntryContainers from './components/EntryContainers.vue'
import EntryFiles from './components/EntryFiles.vue'
import EntryParts from './components/EntryParts.vue'
import Timeline from '@/views/components/Timeline.vue'
import EntryReviewOrder from './components/EntryReviewOrder.vue'
import EntryLoadOrder from './components/EntryLoadOrder.vue'
import EntryAddComment from './components/EntryAddComment.vue'
import EntryEdit from './components/EntryEdit.vue'
import entry from '@/http/requests/entry'
import loading from '@/mixins/Loading'
import moduleEntry from '@/store/entry/moduleEntry'
import { BASE_URL } from '@/urls.js'
import FileList from '@/views/components/FileList.vue'
export default {
  components: {
    EntryDetail,
    EntryContainers,
    EntryFiles,
    EntryParts,
    Timeline,
    EntryReviewOrder,
    EntryLoadOrder,
    EntryAddComment,
    FileList,
    EntryEdit,
  },
  computed: {
    entryId() {
      return this.$route.params.id
    },
    statusLockedNext() {
      let out = this.$i18n.messages[this.$i18n.locale].locked
      if (this.entryDetails.locked == 1) {
        out = this.$i18n.messages[this.$i18n.locale].unlocked
      }
      return out
    },
    isLoading() {
      return (
        this.loading.details ||
        this.loading.containers ||
        this.loading.files ||
        this.loading.invoiceList ||
        this.loading.reviewOrder ||
        this.loading.comments ||
        this.loading.loadOrder
      )
    },
  },
  data() {
    return {
      timeline: [],
      entryDetails: {},
      entryContainers: [],
      entryFiles: [],
      entryInvoiceList: [],
      entryReviewOrder: [],
      entryLoadOrder: [],
      willcard: {},
      loading: {
        details: false,
        containers: false,
        files: false,
        invoiceList: false,
        reviewOrder: false,
        loadOrder: false,
        comments: false,
      },
      disabledSubmitButton: false,
      confirmActive: false,
      confirmActiveLock: false,
      submitButtonText: this.$i18n.messages[this.$i18n.locale].save,
    }
  },
  created() {
    if (!moduleEntry.isRegistered) {
      this.$store.registerModule('entry', moduleEntry)
      moduleEntry.isRegistered = true
    }
  },
  methods: {
    reload() {
      this.getFiles()
      this.getDetails()
    },
    getDetails() {
      this.loading.details = true
      entry
        .show(this.entryId) //FUNKA 27
        .then((res) => {
          this.entryDetails = Object.assign({}, res.data.data)
          this.loading.details = false
        })
        .catch((res) => {
          this.loading.details = false
        })
    },
    getContainers() {
      this.loading.containers = true
      entry
        .getContainers(this.entryId) //FUNKA 27
        .then((res) => {
          this.entryContainers = [...res.data.data]
          this.loading.containers = false
        })
        .catch((res) => {
          this.loading.containers = false
        })
    },
    getFiles() {
      this.loading.files = true
      entry
        .getFiles(this.entryId) //FUNKA 27
        .then((res) => {
          this.entryFiles = [...res.data.data]
          this.loading.files = false
        })
        .catch((res) => {
          this.loading.files = false
        })
    },
    getInvoiceList() {
      this.loading.invoiceList = true
      entry
        .getInvoiceList(this.entryId) //FUNKA 27
        .then((res) => {
          this.entryInvoiceList = [...res.data.data]
          this.loading.invoiceList = false
        })
        .catch((res) => {
          this.loading.invoiceList = false
        })
    },
    getReviewOrder() {
      this.loading.reviewOrder = true
      entry
        .getReviewOrder(this.entryId)
        .then((res) => {
          this.entryReviewOrder = [...res.data.data]
          this.loading.reviewOrder = false
        })
        .catch((res) => {
          this.loading.reviewOrder = false
        })
    },
    getLoadOrder() {
      this.loading.loadOrder = true
      entry
        .getLoadOrder(this.entryId)
        .then((res) => {
          this.entryLoadOrder = [...res.data.data]
          this.loading.loadOrder = false
        })
        .catch((res) => {
          this.loading.loadOrder = false
        })
    },
    getComments() {
      this.loading.comments = true
      entry
        .timeline(this.entryId)
        .then((res) => {
          this.timeline = [...res.data.data]
          this.loading.comments = false
        })
        .catch((res) => {
          this.loading.comments = false
        })
    },
    openCommentSidebar(data) {
      this.$store.dispatch('toggleSidebar', 'entry-add-comment')
    },
    addComment(data) {
      this.timeline.unshift(data)
    },
    inventaryEntry() {
      this.confirmActive = true
    },
    lockEntry() {
      this.confirmActiveLock = true
    },
    updateInventary() {
      this.disabledSubmitButton = true
      this.submitButtonText = `${
        this.$i18n.messages[this.$i18n.locale].loading
      }...`
      let params = { entry_id: this.entryDetails.id }
      if (
        this.entryDetails.in_inventary == null ||
        this.entryDetails.in_inventary == 0
      ) {
        params.in_inventary = 1
      } else {
        params.in_inventary = 0
      }
      entry
        .setInventary(params)
        .then((res) => {
          this.disabledSubmitButton = false
          this.submitButtonText = this.$i18n.messages[this.$i18n.locale].save
          this.entryDetails.in_inventary = params.in_inventary
          this.confirmActive = false
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: this.$i18n.messages[this.$i18n.locale].saved,
          })
          this.getComments()
          this.getDetails()
        })
        .catch((err) => {
          this.disabledSubmitButton = false
          this.submitButtonText = this.$i18n.messages[this.$i18n.locale].save
          this.$vs.notify({
            color: 'danger',
            text: 'Error Catch',
          })
        })
    },
    updateLock() {
      this.disabledSubmitButton = true
      this.submitButtonText = `${
        this.$i18n.messages[this.$i18n.locale].loading
      }...`
      const params = { entry_id: this.entryDetails.id }
      if (this.entryDetails.locked == null || this.entryDetails.locked == 0) {
        params.locked = 1
      } else {
        params.locked = 0
      }
      entry
        .setLock(params)
        .then((res) => {
          this.disabledSubmitButton = false
          this.submitButtonText = this.$i18n.messages[this.$i18n.locale].save
          this.entryDetails.locked = params.locked
          this.confirmActiveLock = false
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: this.$i18n.messages[this.$i18n.locale].saved,
          })
          this.getComments()
        })
        .catch((err) => {
          this.disabledSubmitButton = false
          this.submitButtonText = this.$i18n.messages[this.$i18n.locale].save
          this.$vs.notify({
            color: 'danger',
            text: 'Error Catch',
          })
        })
    },
    containerUpdated() {
      this.getContainers()
    },
    redirectShowQR() {
      window.open(
        BASE_URL + 'internal_api/entries/show_qr/' + this.entryId,
        '_blank'
      )
    },
    redirectPrintQR() {
      window.open(
        `${BASE_URL}qrprint/print_qr_printer?entry_id=${this.entryId}`,
        '_blank'
      )
    },
    editEntry() {
      this.$store.dispatch('toggleSidebar', 'entry-edit')
    },
    getSignature() {
 
      entry
        .getSignature(this.entryId)
        .then((res) => {
          let body = res.data.will_call.body
          let text = body.split(',')
          this.willcard.name = text[0].replace('{ "fullname": ','')
          this.willcard.signature = res.data.will_call.signature
        })
        .catch((res) => {
          console.log(res.data)
        })
    },
  },
  mounted() {
    this.getDetails()
    this.getContainers()
    this.getFiles()
    this.getInvoiceList()
    this.getReviewOrder()
    this.getLoadOrder()
    this.getComments()
    this.getSignature()
  },
  mixins: [loading],
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('entry-detail-loading')
      } else {
        this.closeLoading('entry-detail-loading')
      }
    },
  },
}
</script>

<style>
.display-flex {
  display: flex;
}

.img-signature{
  max-height: 20vh;
}
.card-dh{
  height: 35vh;
}

@media (max-width: 600px) {
  .card-dh{
    height: 55vh;
  }
}

</style>
